/* eslint-disable */
import {
  makeStyles,
  RACCOLOR,
  RACRowTip,
  RACTable,
  RACTableCell,
  RACTableRow,
  Typography,
  RACDateTimeLabel
} from '@rentacenter/racstrap';
import i18n from 'i18next'; // Import i18next
import { useTranslation } from 'react-i18next';;
import React, { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  ApiStateWrapper,
  Loader,
} from '../../../common/ApiStateWrapper/ApiStateWrapper';
import { LegendItemList } from '../../../common/Legend/LegendItemList';
import {
  INITIAL_OFFSET,
  WORKED_HISTORY_ACTIVITY_TYPE_CODES,
  WORKED_HISTORY_API_LIMIT,
  FULL_API_ERROR_MESSAGE
} from '../../../constants/constants';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import {
  PastDueListCustomerStateContext,
  PastDueListCustomerDispatchStateContext,
} from '../../../context/PastDueListCustomer/PastDueListCustomerProvider';
import {
  useWorkedHistory,
  useWorkedHistoryActions,
} from '../../../context/WorkedHistory/WorkedHistoryProvider';
import { ApiErrorModal } from '../../../common/ApiError/ApiError';
import { SurveyForm } from './SurveyForm';
import { WorkedHistoryStatusLegendNames } from '../../../domain/WorkedHistory/WorkedHistory';
import { WorkedHistoryCommitmentType } from '../../../types/types';
import {
  abbrev,
  formatDateString,
  formatPhoneNumber,
  formatStringDateHoursAndMinutes,
  maskData,
} from '../../../utils/utils';
import { WorkedHistoryNotesModal } from './WorkedHistoryNotesModal';
import { CommitmentNotesModal } from './CommitmentNotesModal';
import { getSavedSurvey, getDeliveryAddr } from '../../../api/store';
import { useStoreDetails } from '../../../context/Store/StoreProvider';


const useClasses = makeStyles((theme: any) => ({
  legendWrapper: {
    height: theme.typography.pxToRem(70),
  },
  tableContentColor: {
    color: RACCOLOR.INDEPENDENCE,
  },
  noLeftPadding: {
    paddingLeft: 0,
  },
  tableRoot: {
    marginTop: theme.typography.pxToRem(16),
  },
  tableHead: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: 'white',
  },
  contentHeight: {
    height: theme.typography.pxToRem(330),
  },
  // row: {
  //   display: 'flex',
  // },
  notes: {
    cursor: 'pointer',
  },
  tipRoot: {
    borderLeftWidth: theme.typography.pxToRem(6),
  },
}));

export const WorkedHistory = () => {
  const { t }=useTranslation()
  const [offset, setOffset] = useState<number>(INITIAL_OFFSET);
  const [isFirstFetch, setIsFirstFetch] = useState<boolean>(true);
  const {
    workedHistory: data,
    hasApiError,
    loading,
    reloadWorkedHistory,
    hasMore,
  } = useWorkedHistory();
  const { filter } = useContext(PastDueListCustomerStateContext);

  const { isCommunicationAllowed, customerDetails, recordCheckDataUnmask, isLegalHoldProtected } = useCustomerDetails();
  const { DateTimeLocalization, store } = useStoreDetails();
  const { firstName, lastName, phones } = customerDetails || {};
  const [isApiErrorOpen, setIsApiErrorOpen] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  const { setSeletedFilter } = useContext(
    PastDueListCustomerDispatchStateContext
  );

  const onSelect = (selectedFilter: string) => {
    filter === selectedFilter
      ? setSeletedFilter('')
      : setSeletedFilter(selectedFilter);
  };
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [isCommitmentNotesModalOpen, setIsCommitmentNotesModalOpen] =
    useState(false);
  const [selectedCommitment, setSelectedCommitment] =
    useState<WorkedHistoryCommitmentType | null>();
  const [workedResultText, setWorkedResultText] = useState('');
  const [noteText, setNoteText] = useState('');
  const [openSurvey, setOpenSurvey] = React.useState(false);
  const [surveyDetails, setSurveyDetails] = React.useState<any>({});
  const [surveyCustomerDetails, setSurveyCustomerDetails] = React.useState<any>({});

  const handleCommitmentNotesModalClose = () => {
    setIsCommitmentNotesModalOpen(false);
    setSelectedCommitment(null);
  };
    const getPrimaryPhone = () => {
    let result = '';
    if (!phones || phones.length === 0) return result;
    for (const item of phones) {
      if (item?.primary) {
        result = item.phoneNumber;
      }
    }
    return result;
  }

  const FIELD_VISIT = t("Field Visit");

  const renderTableHead = () => (
    <>
      <RACTableCell>
        <Typography variant="h5">{t('Worked Date & Time')}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t('Worked Result')}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t('Notes')}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t('Commitment Status')}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t('Due Date')}</Typography>
      </RACTableCell>
      <RACTableCell align="center">
        <Typography variant="h5">{t('Days Late')}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t('Contact Method')}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t('Relation')}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t('Source')}</Typography>
      </RACTableCell>
    </>
  );
  const handleSurvey = async (activityItem: any) => {
    try {
      let agrId = activityItem.agreementId;
      let agrNumber = activityItem.agreementNum ? activityItem.agreementNum : '';
      if (!agrId) {
        console.log("AgreementId is missing. Wrong data. Do nothing");
        return;
      }
      const apiCalls = [getSavedSurvey(agrId)];
      apiCalls.push(getDeliveryAddr(agrId));
      const response = await Promise.all(apiCalls);
      setSurveyDetails({
        readOnlyMode: true,
        productDeliveryQn: response[0].deliveryOnTime && response[0].deliveryOnTime == '1' ? 'yes' : 'no',
        rentalAgrQn: response[0].questionsAnswered && response[0].questionsAnswered == '1' ? 'yes' : 'no',
        renewalDateAndAmtQn: response[0].renewalDiscussed && response[0].renewalDiscussed == '1' ? true : false,
        autoEnrollQn: response[0].autopayDiscussed && response[0].autopayDiscussed == '1' ? true : false,
        timelyPayments: response[0].paymentDiscussed && response[0].paymentDiscussed == '1' ? true : false,
        anyOtherQns: response[0].otherQuestions && response[0].otherQuestions == '1' ? 'yes' : 'no',
        additionalNotes: response[0].notes ? response[0].notes : ''
      });

      const details = {
        agreement: {
          agreementId: agrId,
          agreementNumber: agrNumber,
        },
        customerInfo: {
          address: {
            addressLine1: response[1]?.deliveryInformation?.addressLine1 ? response[1].deliveryInformation.addressLine1 : '',
            addressLine2: response[1]?.deliveryInformation?.addressLine2 ? response[1].deliveryInformation.addressLine2 : '',
            city: response[1]?.deliveryInformation?.city ? response[1].deliveryInformation.city : '',
            state: response[1]?.deliveryInformation?.state ? response[1].deliveryInformation.state : ''
          },
          customerId: activityItem.customerId,
          firstName: activityItem.customerFirstName,
          lastName: activityItem.customerLastName,
          phoneNumber: getPrimaryPhone()
        }
      };
      setSurveyCustomerDetails(details);

      setOpenSurvey(true);
    }
    catch (e) {
      setApiErrorMessage(i18n.t(FULL_API_ERROR_MESSAGE));
      setIsApiErrorOpen(true);
      console.log("error", e);
    }

    //set value

    //set to show modal

  }
  const renderTableContent = () => (
    <>
      {data?.map((dataObj, index) => {
        const WorkedResultBody = dataObj.accountActivityType?.description || '';
        const code = dataObj.accountActivityType?.code?.toUpperCase();
        const subCode = dataObj.accountActivitySubType?.code?.toUpperCase();
        const isRecordCheck = subCode === WORKED_HISTORY_ACTIVITY_TYPE_CODES.RECORD_CHECK;

        let description = code === WORKED_HISTORY_ACTIVITY_TYPE_CODES.CALL_CUSTOMER
          ? i18n.t(dataObj.callResultType?.description || '')
          : i18n.t(WorkedResultBody);

        // Append field visit result if applicable
        if (description === FIELD_VISIT && dataObj.fieldVisitResultType?.description) {
          description += `/${dataObj.fieldVisitResultType.description}`;
        }

        // Prefix with CRC if it's a record check
        if (isRecordCheck) {
          description = `CRC/${description}`;
        }

        const workedDateString = `${formatDateString(
          dataObj.activityDate
        )} ${formatStringDateHoursAndMinutes(dataObj.activityDate)}`;

        const noteText = dataObj.commitment?.notes || dataObj?.notes || '';

        const soureName: string | undefined =
          code?.toUpperCase() ===
            WORKED_HISTORY_ACTIVITY_TYPE_CODES.TEXT_RECEIVED
            ? `${firstName} ${lastName}`
            : `${dataObj.coWorker?.firstName || ''} ${dataObj.coWorker?.lastName || ''
            }`;
            const commitmentStatusDescription = dataObj.commitment?.commitmentStatus?.description || ''
        return (
          <RACTableRow key={index} hover backgroundColor={dataObj.color?.row}>
            <RACTableCell
              classes={{
                root: classes.noLeftPadding,
              }}
            >
              <div
              // className={classes.row}
              >
                <RACRowTip
                  classes={{ root: classes.tipRoot }}
                  tipColor={dataObj.color?.tip || RACCOLOR.WHITE}
                />
                {DateTimeLocalization ?
                  <RACDateTimeLabel 
                  value={dataObj.activityDate || ''} 
                  country={store?.countryAbb} 
                  displayType={'ShortDateTime12hr'}
                  className={classes.tableContentColor}
                  />
                  :
                <Typography
                  display="inline"
                  variant="body2"
                  className={classes.tableContentColor}
                >
                  {workedDateString}
                </Typography>
                }
              </div>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2">{i18n.t(description)}</Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography
                noWrap
                variant="body2"
                className={classes.tableContentColor}
              >
                <Typography noWrap variant="body2" color="primary">
                  <span
                    className={classes.notes}
                    onClick={() => {
                      if (dataObj.commitment) {
                        setSelectedCommitment(dataObj.commitment);
                        setIsCommitmentNotesModalOpen(true);
                      } else if (code?.toUpperCase() === WORKED_HISTORY_ACTIVITY_TYPE_CODES.CUST_SURVEY) {
                        handleSurvey(dataObj);
                      }
                      else {
                        setIsNotesModalOpen(true);
                        setWorkedResultText(description || '');
                        setNoteText(noteText);
                      }
                    }}
                  >
                    {i18n.t(code?.toUpperCase() === WORKED_HISTORY_ACTIVITY_TYPE_CODES.CUST_SURVEY ?'Completed Survey' : abbrev(noteText))}
                  </span>
                </Typography>
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {i18n.t(commitmentStatusDescription)}
              </Typography>
            </RACTableCell>
            <RACTableCell>
             {
              DateTimeLocalization ?
                  <RACDateTimeLabel 
                  value={dataObj.pastDueDate || ''} 
                  country={store?.countryAbb} 
                  displayType={'ShortDate'}
                  className={classes.tableContentColor}
                  />
                :
              <Typography variant="body2" className={classes.tableContentColor}>
                {formatDateString(dataObj.pastDueDate)}
              </Typography>
            }
            </RACTableCell>
            <RACTableCell>
              <Typography
                align="center"
                variant="body2"
                className={classes.tableContentColor}
              >
                {dataObj.daysLate}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {dataObj.contactMethod?.contactType === 'phone' && (isLegalHoldProtected ? (
                  formatPhoneNumber(dataObj.contactMethod?.phoneNumberDialed || '', true)
                ) : isRecordCheck ? (
                  maskData(dataObj.contactMethod?.phoneNumberDialed || '', {
                    maskType: !isRecordCheck || recordCheckDataUnmask
                      ? 'unmaskPH'
                      : 'lastFour',
                  })
                ) : (
                  formatPhoneNumber(
                    dataObj.contactMethod?.phoneNumberDialed || '',
                    !isCommunicationAllowed
                  )
                ))}
                {dataObj.contactMethod?.contactType === 'email' && (isLegalHoldProtected ? (
                  dataObj.contactMethod.email ? '********' : ''
                ) : (
                  <>
                    {maskData(dataObj.contactMethod.email || '', {
                    maskType: !isRecordCheck || recordCheckDataUnmask ? 'none' : 'email',
                  })}
                  </>
                ))}
                {dataObj.contactMethod?.contactType === 'address' && (isLegalHoldProtected ? (
                  '********'
                ) : (
                  <>
                    {maskData(dataObj.contactMethod.addressLine || '', {
                    maskType: !isRecordCheck || recordCheckDataUnmask ? 'none' : 'full',
                  })}, {dataObj.contactMethod.city}, {dataObj.contactMethod.state},
                     {dataObj.contactMethod.county} {dataObj.contactMethod.zipCode}
                  </>
                ))}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {dataObj.phoneContact?.relationshipType?.description || ''}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {soureName}
              </Typography>
            </RACTableCell>
          </RACTableRow>
        );
      })}
    </>
  );

  const classes = useClasses();
  const { fetchWorkedHistory } = useWorkedHistoryActions();

  useEffect(() => {
    if (!isFirstFetch && reloadWorkedHistory) {
      fetchWorkedHistory(offset, WORKED_HISTORY_API_LIMIT);
    }
    setIsFirstFetch(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadWorkedHistory]);

  useEffect(() => {
    if (offset === INITIAL_OFFSET && isFirstFetch) {
      fetchWorkedHistory(offset, WORKED_HISTORY_API_LIMIT);
      setIsFirstFetch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isFirstFetch) {
      fetchWorkedHistory(offset, WORKED_HISTORY_API_LIMIT);
    }
    setIsFirstFetch(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  /*
  Increment the offset.
  Fetch is handled in the useEffect that listens on the offset.
  */
  const fetchNextPage = () => {
    /*
    fetchNextPage is used by infinite scroll component
    the first fetch is handled by our component, therefore we are not letting the
    infinite scroll to trigger the first request.
    Handles the case when you apply the filters
    (offset set to 0 -> request is triggered, but infinite scroll is also triggering a request, because its data length is 0)
    */
    data.length > 1 && setOffset(offset + WORKED_HISTORY_API_LIMIT);
  };
const translatedLegendNames = Object.keys(WorkedHistoryStatusLegendNames).map((key:any) => {
    const legend:any = WorkedHistoryStatusLegendNames[key as WorkedHistoryStatusLegend];    
    return {
      ...legend,
      label: t(legend.label)
    };
  });  return (
    <>
      {isNotesModalOpen && (
        <WorkedHistoryNotesModal
          noteText={noteText}
          workedResultText={t(workedResultText)}
          open={isNotesModalOpen}
          onClose={() => setIsNotesModalOpen(false)}
        />
      )}
      {
        <SurveyForm
          inputOpen={openSurvey}
          surveyDetails={surveyDetails}
          customerDetails={surveyCustomerDetails}
          onClose={() => {
            setOpenSurvey(false);
          }}
        />
      }
      {isApiErrorOpen && (
        <ApiErrorModal
          open={isApiErrorOpen}
          message={apiErrorMessage}
          onClose={() => {
            setApiErrorMessage('');
            setIsApiErrorOpen(false);
          }}
        />
      )}
      {isCommitmentNotesModalOpen && selectedCommitment && (
        <CommitmentNotesModal
          commitment={selectedCommitment}
          onClose={handleCommitmentNotesModalClose}
        />
      )}
      <div className={classes.legendWrapper}>
        <LegendItemList
          list={translatedLegendNames}
          onSelect={onSelect}
        />
      </div>
      <InfiniteScroll
        next={fetchNextPage}
        dataLength={data.length}
        hasMore={hasMore}
        height={330}
        loader={loading && data?.length ? <Loader /> : null}
      >
        <ApiStateWrapper
          loading={loading && data?.length === 0}
          hasApiError={hasApiError && data?.length === 0}
          response={data}
          successContent={
            <RACTable
              headClasses={{ root: classes.tableHead }}
              classes={{ root: classes.tableRoot }}
              renderTableHead={renderTableHead}
              renderTableContent={renderTableContent}
            />
          }
          classes={{
            loader: classes.contentHeight,
            apiError: classes.contentHeight,
            noItems: classes.contentHeight,
          }}
        />
      </InfiniteScroll>
    </>
  );
};
